import { PartnerSpotlightStatusesEnum } from 'v2/constants';

export const PARTNER_SPOTLIGHT_STATUSES_ORDER = [
  PartnerSpotlightStatusesEnum.GOLD,
  PartnerSpotlightStatusesEnum.SILVER,
  PartnerSpotlightStatusesEnum.BRONZE,
];
